import { buildUrl } from "../config/urls";
import { fetcher } from "../helpers/fetcher";
import { UploadDetails } from "../routes/tasks/document/models";
export interface PresignedURLResponse {
  presignedUrl: string;
}

export const getPresignedURL = async (
  candidateId: string | undefined,
  apiPath: string,
  applicationId: string,
  uploadDetails: UploadDetails
): Promise<PresignedURLResponse> => {
  if (!candidateId) {
    throw new Error("candidate id not found for document submission!");
  }

  const url = buildUrl(apiPath, {
    candidateId,
    applicationId,
  });
  // error in getting presigned url from CDS will result in exception, which will lead to error message on UI.
  // Candidate will need to retry the upload when there is error message
  return await fetcher(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(uploadDetails),
  });
};
